/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* Event agenda metadata and filters. Canonical post HTML; no metadata tags. */
(function () {
    const cards = Array.from(document.querySelectorAll('[data-event-card]'));
    const detail = document.querySelector('[data-event-detail]');
    const agenda = document.querySelector('[data-events-api-key]');
    if (!cards.length && !detail && !agenda) return;

    function normalize(value) {
        return (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    }

    function isPlaceholder(value) {
        return !value || normalize(value).includes('a confirmar') || normalize(value).includes('nao informado');
    }

    const titleOverrides = {
        ai: 'AI', api: 'API', aws: 'AWS', b2b: 'B2B', chatgpt: 'ChatGPT', ceia: 'CEIA',
        genai: 'GenAI', google: 'Google', gtc: 'GTC', ia: 'IA', ibm: 'IBM', ifood: 'iFood',
        linkedin: 'LinkedIn', meta: 'Meta', microsoft: 'Microsoft', nvidia: 'NVIDIA',
        openai: 'OpenAI', rd: 'RD', saas: 'SaaS', sap: 'SAP', tdc: 'TDC', tiktok: 'TikTok',
        vtex: 'VTEX', youtube: 'YouTube'
    };
    const titleLowerWords = new Set(['a', 'as', 'com', 'da', 'das', 'de', 'do', 'dos', 'e', 'em', 'na', 'nas', 'no', 'nos', 'o', 'os', 'para', 'por']);

    function displayTitle(value) {
        // Some older projections arrive in all caps. Keep the Ghost/source title
        // untouched and only normalize the visible listing/detail heading.
        const letters = (value || '').match(/[A-Za-zÀ-ÖØ-öø-ÿ]/g) || [];
        if (!value || !letters.length || !letters.every((letter) => letter === letter.toLocaleUpperCase('pt-BR'))) return value;
        return value.split(/\s+/).map((word, index) => {
            const match = word.match(/^([^A-Za-zÀ-ÖØ-öø-ÿ0-9_]*)([A-Za-zÀ-ÖØ-öø-ÿ0-9_]+)([^A-Za-zÀ-ÖØ-öø-ÿ0-9_]*)$/);
            if (!match) return word;
            const [, prefix, core, suffix] = match;
            const lowered = core.toLocaleLowerCase('pt-BR');
            let display = titleOverrides[lowered];
            if (!display && index > 0 && titleLowerWords.has(lowered)) display = lowered;
            if (!display && (/^\d{4}$/.test(core) || (/\d/.test(core) && core === core.toLocaleUpperCase('pt-BR')))) display = core;
            if (!display && core.length <= 3 && core === core.toLocaleUpperCase('pt-BR')) display = core;
            if (!display) display = lowered.charAt(0).toLocaleUpperCase('pt-BR') + lowered.slice(1);
            return prefix + display + suffix;
        }).join(' ');
    }

    function safeHttpUrl(value) {
        if (typeof value !== 'string') return '';
        const candidate = value.trim();
        if (!candidate || candidate.length > 2048 || /[\s\u0000-\u001f\u007f]/.test(candidate) || /%(?![0-9a-f]{2})/i.test(candidate)) return '';
        try {
            const url = new URL(candidate);
            if (!/^https?:$/.test(url.protocol) || !url.hostname || url.hostname.endsWith('.') || url.username || url.password) return '';
            return url.href;
        } catch (error) {
            return '';
        }
    }

    function readMetadata(element) {
        const template = element.querySelector('template[data-event-source]');
        const source = template
            ? new DOMParser().parseFromString(template.content.textContent, 'text/html')
            : element.querySelector('.event-detail-body');
        const metadata = source?.querySelector('[data-event-metadata], section[data-event-date], section[data-event-start]');
        const fields = {};
        source?.querySelectorAll('dl dt').forEach((label) => {
            const value = label.nextElementSibling;
            if (value?.tagName === 'DD') fields[normalize(label.textContent)] = value.textContent.trim();
        });
        // Ghost's HTML-to-Lexical import can flatten definition lists to strong labels.
        source?.querySelectorAll('p > strong').forEach((label) => {
            let value = '';
            for (let node = label.nextSibling; node && node.nodeName !== 'STRONG'; node = node.nextSibling) value += node.textContent;
            const key = normalize(label.textContent);
            if (value.trim() && !fields[key]) fields[key] = value.trim();
        });
        const attrs = metadata?.dataset || {};
        return {
            date: attrs.eventDate || attrs.eventStart || fields['data e hora'] || fields.data || '',
            start: attrs.eventStart || '',
            dateLabel: fields['data e hora'] || '',
            location: attrs.eventLocation || [fields.local, fields.endereco].filter(Boolean).join(' — '),
            city: (attrs.eventCity || '').trim().replace(/\s+/g, ' '),
            uf: (attrs.eventUf || '').trim().toUpperCase(),
            format: attrs.eventFormat || fields.modalidade || '',
            price: attrs.eventPrice || fields.preco || fields.investimento || ''
        };
    }

    function calendarDate(value) {
        let match = value.match(/^(\d{4})-(\d{2})-(\d{2})(?:$|[T\s])/);
        if (!match) {
            const local = value.match(/\b(\d{2})\/(\d{2})\/(\d{4})\b/);
            if (local) match = [local[0], local[3], local[2], local[1]];
        }
        if (!match) return '';
        const iso = `${match[1]}-${match[2]}-${match[3]}`;
        const date = new Date(`${iso}T12:00:00`);
        return !Number.isNaN(date.getTime()) && date.getFullYear() === +match[1] && date.getMonth() + 1 === +match[2] && date.getDate() === +match[3] ? iso : '';
    }

    function hydrate(element) {
        const data = readMetadata(element);
        const isCard = element !== detail;
        const display = element.querySelector('.event-detail-header') || element;
        const isoDate = calendarDate(data.date);
        const date = isoDate ? new Date(`${isoDate}T12:00:00`) : null;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const past = date && date < today;
        element.dataset.eventState = past ? 'past' : 'upcoming';
        element.dataset.eventDate = isoDate;
        element.dataset.eventFormat = normalize(data.format);
        element.dataset.eventPrice = normalize(data.price);
        element.dataset.eventCityLabel = data.city && normalize(data.city) !== 'online' ? (data.uf ? `${data.city}/${data.uf}` : `${data.city} — UF não informada`) : '';
        element.dataset.eventCityKey = normalize(element.dataset.eventCityLabel);
        display.querySelectorAll('[data-event-title]').forEach((node) => { node.textContent = displayTitle(node.textContent.trim()); });
        display.querySelectorAll('[data-event-status]').forEach((node) => { node.textContent = past ? 'Encerrado' : 'Próximo evento'; });
        display.querySelectorAll('[data-event-format]').forEach((node) => {
            node.textContent = data.format || 'Modalidade a confirmar';
            node.hidden = isCard && isPlaceholder(data.format);
        });
        display.querySelectorAll('[data-event-location]').forEach((node) => { node.textContent = data.location || 'Local a confirmar'; });
        display.querySelectorAll('[data-event-price]').forEach((node) => {
            node.textContent = data.price || 'Preço a confirmar';
            node.hidden = isCard && isPlaceholder(data.price);
        });
        if (date) {
            const formatted = new Intl.DateTimeFormat('pt-BR', {day: '2-digit', month: 'long', year: 'numeric'}).format(date);
            display.querySelectorAll('[data-event-date]').forEach((node) => { node.textContent = formatted; });
            const day = element.querySelector('.event-card-day');
            const month = element.querySelector('.event-card-month');
            if (day) day.textContent = new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(date);
            if (month) {
                const monthName = new Intl.DateTimeFormat('pt-BR', {month: 'short'}).format(date).replace('.', '');
                month.textContent = `${monthName} ${date.getFullYear()}`;
            }
        }
        return {data, isoDate, past};
    }

    cards.forEach(hydrate);
    const list = document.querySelector('[data-events-list]');
    if (list) {
        cards.sort((first, second) => (second.dataset.eventDate || '').localeCompare(first.dataset.eventDate || ''));
        cards.forEach((card) => list.append(card));
    }
    if (detail) {
        const hydrated = hydrate(detail);
        const setExternalLink = (selector, value) => {
            const link = detail.querySelector(selector);
            const url = safeHttpUrl(value);
            if (!link || !url) return;
            link.href = url;
            link.hidden = false;
        };
        const contentMetadata = detail.querySelector('.event-detail-body [data-event-official-url], .event-detail-body [data-event-registration-url]');
        setExternalLink('[data-event-official-link]', contentMetadata?.dataset.eventOfficialUrl);
        setExternalLink('[data-event-registration-link]', contentMetadata?.dataset.eventRegistrationUrl);
        detail.querySelectorAll('.event-detail-body a[href]').forEach((link) => {
            const url = safeHttpUrl(link.getAttribute('href') || link.href);
            if (url && new URL(url).origin !== window.location.origin) {
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
            }
        });
        const schema = document.querySelector('[data-event-jsonld]');
        if (schema && !hydrated.isoDate) {
            schema.remove();
        } else if (schema) {
            const json = JSON.parse(schema.textContent);
            json.startDate = hydrated.data.start || hydrated.isoDate;
            json.eventStatus = hydrated.past ? 'https://schema.org/EventCompleted' : 'https://schema.org/EventScheduled';
            const format = normalize(hydrated.data.format);
            const hybrid = format.includes('hibrido');
            json.eventAttendanceMode = hybrid ? 'https://schema.org/MixedEventAttendanceMode' : format.includes('online') ? 'https://schema.org/OnlineEventAttendanceMode' : 'https://schema.org/OfflineEventAttendanceMode';
            json.location = format.includes('online') && !hybrid ? {'@type': 'VirtualLocation', url: window.location.href} : {'@type': 'Place', name: hydrated.data.location || 'Brasil'};
            schema.textContent = JSON.stringify(json);
        }
    }

    const buttons = document.querySelectorAll('[data-event-filter]');
    const count = document.querySelector('[data-event-count]');
    const empty = document.querySelector('[data-events-empty]');
    const pagination = document.querySelector('[data-events-pagination]');
    const previousPage = document.querySelector('[data-events-page-prev]');
    const nextPage = document.querySelector('[data-events-page-next]');
    const pageStatus = document.querySelector('[data-events-page-status]');
    const eventsHeading = document.querySelector('#events-heading, [data-events-heading]');
    const monthSelect = document.querySelector('[data-event-month]');
    const citySelect = document.querySelector('select[data-event-city]');
    const loadStatus = document.querySelector('[data-events-load-status]');
    const retry = document.querySelector('[data-events-retry]');
    let complete = !agenda;
    let loading = false;
    const pageSize = 25;
    let activeFilter = 'all';
    let currentPage = 1;

    function isPhysical(card) {
        return /presencial|hibrido/.test(card.dataset.eventFormat);
    }

    function matchesFilter(card) {
        if (monthSelect?.value && !card.dataset.eventDate.startsWith(monthSelect.value + '-')) return false;
        if (citySelect?.value && (!isPhysical(card) || card.dataset.eventCityKey !== citySelect.value)) return false;
        if (activeFilter === 'all') return true;
        const format = normalize(card.dataset.eventFormat);
        return activeFilter === card.dataset.eventState || (activeFilter === 'gratuito' && /gratuit|gratis|free/.test(normalize(card.dataset.eventPrice))) || format.includes(activeFilter) || (format.includes('hibrido') && (activeFilter === 'online' || activeFilter === 'presencial'));
    }

    function renderPage() {
        const matchingCards = cards.filter(matchesFilter);
        const totalPages = Math.max(1, Math.ceil(matchingCards.length / pageSize));
        currentPage = Math.min(currentPage, totalPages);
        const pageStart = (currentPage - 1) * pageSize;
        const visibleCards = new Set(matchingCards.slice(pageStart, pageStart + pageSize));
        cards.forEach((card) => { card.hidden = !visibleCards.has(card); });
        if (count) count.textContent = complete ? matchingCards.length : '—';
        if (empty) empty.hidden = !complete || matchingCards.length !== 0;
        if (pagination) pagination.hidden = matchingCards.length <= pageSize;
        if (previousPage) previousPage.disabled = currentPage === 1;
        if (nextPage) nextPage.disabled = currentPage === totalPages;
        if (pageStatus) pageStatus.textContent = `Página ${currentPage} de ${totalPages}`;
    }

    function renderPageAndAlign() {
        renderPage();
        if (eventsHeading && typeof eventsHeading.scrollIntoView === 'function') {
            eventsHeading.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    }

    buttons.forEach((button) => button.addEventListener('click', function () {
        buttons.forEach((item) => { item.classList.remove('is-active'); item.setAttribute('aria-pressed', 'false'); });
        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');
        activeFilter = button.dataset.eventFilter;
        if (citySelect) {
            if (activeFilter === 'online') citySelect.value = '';
            citySelect.disabled = !complete || activeFilter === 'online';
        }
        currentPage = 1;
        renderPage();
    }));
    if (previousPage) previousPage.addEventListener('click', function () { currentPage -= 1; renderPageAndAlign(); });
    if (nextPage) nextPage.addEventListener('click', function () { currentPage += 1; renderPageAndAlign(); });
    if (monthSelect) monthSelect.addEventListener('change', function () {
        currentPage = 1;
        renderPage();
    });
    if (citySelect) citySelect.addEventListener('change', function () {
        currentPage = 1;
        renderPage();
    });

    function populateCities() {
        if (!citySelect) return;
        const cities = new Map();
        cards.filter(isPhysical).forEach((card) => {
            if (card.dataset.eventCityKey) cities.set(card.dataset.eventCityKey, card.dataset.eventCityLabel);
        });
        citySelect.replaceChildren(new Option('Todas as cidades', ''));
        [...cities].sort((first, second) => first[1].localeCompare(second[1], 'pt-BR')).forEach(([key, label]) => citySelect.add(new Option(label, key)));
        citySelect.disabled = activeFilter === 'online';
    }

    function populateMonths() {
        if (!monthSelect) return;
        const parts = new Intl.DateTimeFormat('en-US', {timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit'}).formatToParts(new Date());
        const currentMonth = `${parts.find((part) => part.type === 'year').value}-${parts.find((part) => part.type === 'month').value}`;
        const months = [...new Set(cards.map((card) => card.dataset.eventDate.slice(0, 7)).filter((month) => month && month >= currentMonth))].sort();
        monthSelect.replaceChildren(new Option('Todos os meses', ''));
        months.forEach((month) => {
            const label = new Intl.DateTimeFormat('pt-BR', {month: 'long', year: 'numeric', timeZone: 'UTC'}).format(new Date(`${month}-01T12:00:00Z`));
            monthSelect.add(new Option(label, month));
        });
        monthSelect.disabled = false;
    }

    function createCard(post) {
        const card = document.querySelector('[data-event-card-template]').content.firstElementChild.cloneNode(true);
        card.dataset.eventId = post.id;
        // Keep publisher HTML inert; use the same canonical parser as server cards.
        card.querySelector('template[data-event-source]').content.textContent = post.html || '';
        const link = card.querySelector('.event-card-link');
        const url = safeHttpUrl(post.url);
        if (!url || new URL(url).origin !== window.location.origin) throw new Error('Invalid event URL');
        link.href = url;
        link.setAttribute('aria-label', `Ver detalhes de ${post.title}`);
        card.querySelector('[data-event-title]').textContent = post.title;
        const excerpt = card.querySelector('.event-card-excerpt');
        excerpt.textContent = post.custom_excerpt || '';
        excerpt.hidden = !post.custom_excerpt;
        const imageUrl = safeHttpUrl(post.feature_image);
        const figure = card.querySelector('.event-card-image');
        figure.hidden = !imageUrl;
        if (imageUrl) {
            const image = figure.querySelector('img');
            image.src = imageUrl;
            image.alt = post.feature_image_alt || post.title;
        }
        hydrate(card);
        return card;
    }

    async function loadCollection() {
        if (loading) return;
        loading = true;
        monthSelect.disabled = true;
        if (citySelect) citySelect.disabled = true;
        retry.hidden = true;
        loadStatus.textContent = 'Carregando agenda completa… A lista abaixo é parcial.';
        list.setAttribute('aria-busy', 'true');
        try {
            const endpoint = new URL(agenda.dataset.eventsApiUrl, window.location.href);
            if (endpoint.origin !== window.location.origin || !agenda.dataset.eventsApiKey) throw new Error('Missing Content API configuration');
            endpoint.searchParams.set('key', agenda.dataset.eventsApiKey);
            endpoint.searchParams.set('filter', 'tag:hash-eventos');
            endpoint.searchParams.set('limit', '100');
            endpoint.searchParams.set('formats', 'html');
            endpoint.searchParams.set('order', 'published_at desc,id desc');
            const posts = new Map();
            let page = 1;
            let total;
            do {
                endpoint.searchParams.set('page', String(page));
                const controller = new AbortController();
                const timeout = setTimeout(() => controller.abort(), 20000);
                let data;
                try {
                    const response = await fetch(endpoint.href, {signal: controller.signal, credentials: 'omit'});
                    if (!response.ok) throw new Error('Content API request failed');
                    data = await response.json();
                } finally {
                    clearTimeout(timeout);
                }
                const pagination = data.meta?.pagination;
                if (!Array.isArray(data.posts) || !pagination || pagination.page !== page || !Number.isInteger(pagination.total) || pagination.total < 0 || !Number.isInteger(pagination.pages) || pagination.pages < 1 || (total !== undefined && total !== pagination.total)) throw new Error('Incomplete event collection');
                total = pagination.total;
                for (const post of data.posts) {
                    if (typeof post.id !== 'string' || !post.id || typeof post.title !== 'string' || typeof post.html !== 'string') throw new Error('Invalid event post');
                    if (!posts.has(post.id)) posts.set(post.id, post);
                }
                const next = pagination.next;
                if (next !== null && (!Number.isInteger(next) || next !== page + 1 || next > pagination.pages)) throw new Error('Invalid next page');
                if (next === null && page !== pagination.pages) throw new Error('Missing event page');
                page = next;
            } while (page !== null);
            if (posts.size !== total) throw new Error('Incomplete event collection');
            const existing = new Map(cards.map((card) => [card.dataset.eventId, card]));
            const collection = Array.from(posts.values(), (post) => existing.get(post.id) || createCard(post));
            collection.sort((first, second) => (second.dataset.eventDate || '').localeCompare(first.dataset.eventDate || ''));
            list.replaceChildren(...collection);
            cards.splice(0, cards.length, ...collection);
            complete = true;
            currentPage = 1;
            populateMonths();
            populateCities();
            loadStatus.textContent = '';
            loadStatus.hidden = true;
        } catch (error) {
            loadStatus.textContent = 'Não foi possível carregar a agenda completa. A lista abaixo é parcial; tente novamente para filtrar por mês e cidade.';
            retry.hidden = false;
        } finally {
            loading = false;
            list.setAttribute('aria-busy', 'false');
            renderPage();
        }
    }

    if (buttons.length) buttons[0].click();
    if (agenda && list && monthSelect && retry && loadStatus) {
        retry.addEventListener('click', loadCollection);
        loadCollection();
    } else {
        populateMonths();
        populateCities();
    }
})();
